import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CallGroupAddNewMemberGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
}>;


export type CallGroupAddNewMemberGroupQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, groupType: Types.GroupType, numberId: number, hasAddressBook: boolean, name: string, size?: number | null, number?: { __typename?: 'Number', domainId: number } | null, members: Array<{ __typename?: 'GroupMembership', numberId: number, callOrder?: number | null, sectionIndex: number, controllingLine: boolean, allowEditAddressBook: boolean, number?: { __typename?: 'Number', shortNumber?: string | null, extension?: { __typename?: 'User', displayName: string, alternateCallerNumberId?: number | null } | null } | null }> } | null> } | null };

export type CallGroupAddNewMemberExtensionQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type CallGroupAddNewMemberExtensionQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, numberId: number } | null> } | null, usersCapabilities?: Array<{ __typename?: 'UserCapabilities', id?: number | null, capabilities?: Array<Types.Capability | null> | null } | null> | null };


export const CallGroupAddNewMemberGroupDocument = gql`
    query CallGroupAddNewMemberGroup($groupId: Int!) {
  groups(id: $groupId) {
    items {
      id
      groupType
      numberId
      hasAddressBook
      name
      size
      number {
        domainId
      }
      members {
        numberId
        callOrder
        sectionIndex
        controllingLine
        allowEditAddressBook
        number {
          shortNumber
          extension {
            displayName
            alternateCallerNumberId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCallGroupAddNewMemberGroupQuery__
 *
 * To run a query within a React component, call `useCallGroupAddNewMemberGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallGroupAddNewMemberGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallGroupAddNewMemberGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useCallGroupAddNewMemberGroupQuery(baseOptions: Apollo.QueryHookOptions<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables> & ({ variables: CallGroupAddNewMemberGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables>(CallGroupAddNewMemberGroupDocument, options);
      }
export function useCallGroupAddNewMemberGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables>(CallGroupAddNewMemberGroupDocument, options);
        }
export function useCallGroupAddNewMemberGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables>(CallGroupAddNewMemberGroupDocument, options);
        }
export type CallGroupAddNewMemberGroupQueryHookResult = ReturnType<typeof useCallGroupAddNewMemberGroupQuery>;
export type CallGroupAddNewMemberGroupLazyQueryHookResult = ReturnType<typeof useCallGroupAddNewMemberGroupLazyQuery>;
export type CallGroupAddNewMemberGroupSuspenseQueryHookResult = ReturnType<typeof useCallGroupAddNewMemberGroupSuspenseQuery>;
export type CallGroupAddNewMemberGroupQueryResult = Apollo.QueryResult<CallGroupAddNewMemberGroupQuery, CallGroupAddNewMemberGroupQueryVariables>;
export const CallGroupAddNewMemberExtensionDocument = gql`
    query CallGroupAddNewMemberExtension($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      id
      numberId
    }
  }
  usersCapabilities(domainId: $domainId) {
    id
    capabilities
  }
}
    `;

/**
 * __useCallGroupAddNewMemberExtensionQuery__
 *
 * To run a query within a React component, call `useCallGroupAddNewMemberExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallGroupAddNewMemberExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallGroupAddNewMemberExtensionQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useCallGroupAddNewMemberExtensionQuery(baseOptions: Apollo.QueryHookOptions<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables> & ({ variables: CallGroupAddNewMemberExtensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables>(CallGroupAddNewMemberExtensionDocument, options);
      }
export function useCallGroupAddNewMemberExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables>(CallGroupAddNewMemberExtensionDocument, options);
        }
export function useCallGroupAddNewMemberExtensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables>(CallGroupAddNewMemberExtensionDocument, options);
        }
export type CallGroupAddNewMemberExtensionQueryHookResult = ReturnType<typeof useCallGroupAddNewMemberExtensionQuery>;
export type CallGroupAddNewMemberExtensionLazyQueryHookResult = ReturnType<typeof useCallGroupAddNewMemberExtensionLazyQuery>;
export type CallGroupAddNewMemberExtensionSuspenseQueryHookResult = ReturnType<typeof useCallGroupAddNewMemberExtensionSuspenseQuery>;
export type CallGroupAddNewMemberExtensionQueryResult = Apollo.QueryResult<CallGroupAddNewMemberExtensionQuery, CallGroupAddNewMemberExtensionQueryVariables>;